import moment from "moment";
const BettingUnSettledDetail = ({ setSingle, data, betType }) => {
  const BET_SECTIONS = [
    { key: "betList", label: "Exchange" },
    { key: "bookmakerList", label: "Bookmaker" },
    { key: "sessionBetList", label: "Session" },
    { key: "sportBookBetList", label: "SportsBook" },
  ];

  // Combine all bets from all 4 arrays into one flat list with a source label
  const allBets = BET_SECTIONS.flatMap(({ key, label }) =>
    (data?.[key] || []).map((bet) => ({ ...bet, _source: label })),
  );

  return (
    <div
      _ngcontent-serverapp-c221247831
      className="dialog-wrap ng-trigger ng-trigger-dialogTriggerAni ng-tns-c221247831-105 ng-star-inserted"
    >
      <div
        _ngcontent-serverapp-c221247831
        className="top-bar ng-tns-c221247831-105"
      >
        <div
          _ngcontent-serverapp-c221247831
          className="bar-title ng-tns-c221247831-105"
        >
          Betting Records Details
        </div>
        <div
          onClick={() => setSingle({})}
          _ngcontent-serverapp-c221247831
          className="back-btn ng-tns-c221247831-105"
          style={{
            "mask-image": 'url("/assets/Other/icon-arrow-type01.svg")',
          }}
        />
      </div>

      <ul
        _ngcontent-serverapp-c221247831
        className="cricket-list-content ng-tns-c221247831-105"
      >
        {allBets?.length > 0 &&
          allBets?.map((res) => {
            return (
              <li
                style={{ color: "white" }}
                _ngcontent-serverapp-c3238644402
                className={`accordion-wrap ng-tns-c3238644402-106 ng-star-inserted`}
              >
                <div
                  _ngcontent-serverapp-c3238644402
                  className={`accordion-header ng-tns-c3238644402-106 ng-star-inserted`}
                >
                  <div
                    style={{ display: "block" }}
                    _ngcontent-serverapp-c3238644402
                    className="main-info ng-tns-c3238644402-106"
                  >
                    <div
                      _ngcontent-serverapp-c3238644402
                      className="title ng-tns-c3238644402-106"
                    >
                      <span
                        _ngcontent-serverapp-c3238644402
                        className="category-type ng-tns-c3238644402-106"
                      >
                        {res?.teamName || res?.fancyName} -{" "}
                        {res?.runnerName || res?._source}
                      </span>
                      <div
                        _ngcontent-serverapp-c3238644402
                        className="parlay-type ng-tns-c3238644402-106"
                        style={{ textTransform: "uppercase" }}
                      >
                        ( {res?.betType || res?.type} )
                      </div>
                    </div>
                    {/* <div
                                    _ngcontent-serverapp-c3238644402
                                    className="arrow-circle ng-tns-c3238644402-106"
                                  >
                                    <div
                                      _ngcontent-serverapp-c3238644402
                                      className="arrow ng-tns-c3238644402-106"
                                      style={{
                                        "mask-image":
                                          'url("/assets/Other/accordion-arrow.svg")',
                                      }}
                                    />
                                  </div>
                                  <div
                                    _ngcontent-serverapp-c3238644402
                                    className="settled-date ng-tns-c3238644402-106"
                                  >
                                    Settled Date
                                  </div> */}
                  </div>
                  <div
                    _ngcontent-serverapp-c3238644402
                    className="betting-info ng-tns-c3238644402-106"
                  >
                    <div
                      _ngcontent-serverapp-c3238644402
                      className="avg-odds ng-tns-c3238644402-106"
                    >
                      <svg
                        _ngcontent-serverapp-c3238644402
                        className="item-icon ng-tns-c3238644402-106"
                      >
                        <circle
                          _ngcontent-serverapp-c3238644402
                          cx={9}
                          cy={9}
                          r={9}
                          className="circle ng-tns-c3238644402-106"
                        />
                        <use
                          _ngcontent-serverapp-c3238644402
                          href={"/assets/Other/icon-odds.svg"}
                          className="icon ng-tns-c3238644402-106"
                        />
                      </svg>
                      <strong
                        _ngcontent-serverapp-c3238644402
                        className="ng-tns-c3238644402-106"
                      >
                        {betType != "fancy"
                          ? res?.bhav
                          : `${res?.betRun} / ${res?.bhav}`}
                      </strong>
                      <span
                        _ngcontent-serverapp-c3238644402
                        className="ng-tns-c3238644402-106"
                      >
                        Avg. Odds
                      </span>
                    </div>

                    <div
                      _ngcontent-serverapp-c3238644402
                      className="avg-odds  ng-tns-c3238644402-106"
                    >
                      <svg
                        _ngcontent-serverapp-c3238644402
                        className="item-icon ng-tns-c3238644402-106"
                      >
                        <circle
                          _ngcontent-serverapp-c3238644402
                          cx={9}
                          cy={9}
                          r={9}
                          className="circle ng-tns-c3238644402-106"
                        />
                        <use
                          _ngcontent-serverapp-c3238644402
                          href="/assets/Other/icon-stake.svg"
                          className="icon ng-tns-c3238644402-106"
                        />
                      </svg>
                      <strong
                        _ngcontent-serverapp-c3238644402
                        className="ng-tns-c3238644402-106"
                      >
                        {res?.amount}
                      </strong>
                      <span
                        _ngcontent-serverapp-c3238644402
                        className="ng-tns-c3238644402-106"
                      >
                        Stake ($)
                      </span>
                    </div>
                  </div>
                  <div
                    _ngcontent-serverapp-c3238644402
                    className="bet-bid ng-tns-c3238644402-106"
                  >
                    {" "}
                    BID :{" "}
                    <span
                      _ngcontent-serverapp-c3238644402
                      className="ng-tns-c3238644402-106"
                    >
                      {res?.matchBetId}
                    </span>
                  </div>
                  <div
                    _ngcontent-serverapp-c3238644402
                    className="bet-placed ng-tns-c3238644402-106"
                  >
                    {" "}
                    Bet Placed :{" "}
                    <span
                      _ngcontent-serverapp-c3238644402
                      className="ng-tns-c3238644402-106"
                    >
                      {moment(res?.timeInserted).format("YYYY-MM-DD HH:MM:SS")}
                    </span>
                  </div>
                </div>
              </li>
            );
          })}
      </ul>
    </div>
  );
};

export default BettingUnSettledDetail;
